import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type PushNotificationState = {
  isShowPushNotificationWarning: boolean;
  pushNotificationStatus: PermissionState | string;
  isOpenPushNotificationModal: boolean;
  canDismiss: boolean;
  isModalShowed: boolean;
};

const initialState: PushNotificationState = {
  isShowPushNotificationWarning: true,
  isOpenPushNotificationModal: false,
  pushNotificationStatus: '',
  canDismiss: false,
  isModalShowed: false,
};

const pushNotificationsReducer = createSlice({
  name: 'pushNotifications',
  initialState,
  reducers: {
    setPushNotificationStatus: (state, action: PayloadAction<PermissionState | string>) => {
      state.pushNotificationStatus = action.payload;
    },
    setIsModalShowed: (state, action: PayloadAction<boolean>) => {
      state.isModalShowed = action.payload;
    },
    setIsOpenPushNotificationModal: (state, action: PayloadAction<boolean>) => {
      state.isOpenPushNotificationModal = action.payload;
    },
    setCanDismiss: (state, action: PayloadAction<boolean>) => {
      state.canDismiss = action.payload;
    },
    setIsShowPushNotificationWarning: (state, action: PayloadAction<boolean>) => {
      state.isShowPushNotificationWarning = action.payload;
    },
  },
});

export const {
  setPushNotificationStatus,
  setIsOpenPushNotificationModal,
  setIsShowPushNotificationWarning,
  setCanDismiss,
  setIsModalShowed,
} = pushNotificationsReducer.actions;
export default pushNotificationsReducer.reducer;
